import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from '@/components/UI/'
import vueClickOutsideElement from 'vue-click-outside-element'
import vClickOutside from 'click-outside-vue3'
import Vue3Lottie from 'vue3-lottie'
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import { initYandexMetrika } from 'yandex-metrika-vue3';
import Toast from "vue-toastification";
import '@/static/style/toast.scss';
import { Skeletor } from 'vue-skeletor';
import '@/static/style/skeletor.scss';

const app = createApp(App)
app.provide('print', window.print)
components.forEach(component => {
    // Каждый компонент задаёт name через export default, но в типах DefineComponent оно опционально
    if (component.name) {
        app.component(component.name, component)
    }
})

app.component(Skeletor.name, Skeletor);

app.use(initYandexMetrika, {
    id: '98002639',
    router: router,
    env: process.env.VUE_APP_METRIKA,
    scriptSrc: "https://mc.yandex.ru/metrika/tag.js",
    options: {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
    }
})

const toastOptions = {
    transition: "Vue-Toastification__bounce",
    containerClassName: "vita-toast-container",
    maxToasts: 10,
    newestOnTop: true,
    icon: false,
    closeButton: false,
    hideProgressBar: true
}

app.use(Toast, toastOptions);

app.use(Vue3Lottie).use(vClickOutside).use(vueClickOutsideElement).use(store).use(router).use(PerfectScrollbarPlugin).mount('#app')

